export const trashStyles = {
  borderRadius: 100,
  backgroundColor: "rgb(142 22 31 / 10%)",
};
export const ghostBlackStyles = {
  borderRadius: 100,
  backgroundColor: "var(--ghostBlack)",
};

export const filterStyles = {
  width: "3rem",
  borderRadius: 100,
  backgroundColor: "rgb(6 15 22 / 10%)",
};
